import { combineReducers } from 'redux';
import activation from './activation';
import analytics from './analytics';
import assets from './assets';
import attributes from './attributes';
import auth from './auth';
import block from './block';
import catalogs from './catalogs';
import contentBuilder from './contentBuilder';
import dataExtensions from './dataExtensions';
import fallback from './fallback';
import flags from './flags';
import imports from './imports';
import importConfiguration from './importConfiguration';
import profileBrowser from './profileBrowser';
import profileUpload from './profileUpload';
import reports from './reports';
import rules from './rules';
import selections from './selections';
import tags from './tags';

export default combineReducers({
  activation,
  analytics,
  assets,
  attributes,
  auth,
  block,
  catalogs,
  contentBuilder,
  dataExtensions,
  fallback,
  flags,
  imports,
  importConfiguration,
  profileBrowser,
  profileUpload,
  reports,
  rules,
  selections,
  tags
});
